import { cloneElement, FunctionalComponent, toChildArray } from 'preact';

import { BuildingReviewButtonTemplatePropsInterface } from 'common/module/building-review/button/template-props.interface';

export const BuildingReviewButtonTemplate: FunctionalComponent<BuildingReviewButtonTemplatePropsInterface> = (props) =>
  cloneElement((toChildArray(props.children) as preact.JSX.Element[])[0], { onClick: props.onClickButton });
